import React, { Component, Fragment } from 'react'
import CouncillorAppBar from '../../components/CouncillorAppBar'
import { CardContent } from 'material-ui/Card'
import Page from '../Page'
import PageCard from '../PageCard'
import analytics from '../../utils/analytics'
import type { Councillor } from '../../types/Councillor'
import MetricVsAverage from '../MetricVsAverage'

type Props = Councillor & {
  averageAttendanceRate: number,
  secretMeetingsRateAverage: number,
  numberOfPeoplePerCouncillor: number
}

class CouncillorPage extends Component<Props> {
  componentDidMount () {
    analytics.track('Councillor Viewed', {
      name: this.props.name
    })
  }

  kFormatter = (num: number) => {
    const kFormatted = num > 999
      ? `${(num/1000).toFixed(1).replace(/\.0$/, '')}K`
      : num

    return (
      <Fragment>
        {kFormatted}<span className='f4 silver pl2'>people</span>
      </Fragment>
    )
  }

  percentageFormatter = (num: number) => `${num}%`

  render() {
    const {
      name,
      firstName,
      title,
      pictureUrl,
      isMayor,

      numberOfPeopleRepresented,
      numberOfPeoplePerCouncillor,

      // meetings values
      attendanceRate,
      averageAttendanceRate,
      secretMeetingsRate,
      secretMeetingsRateAverage
    } = this.props

    return (
      <Fragment>
        <CouncillorAppBar
          backLink='/toronto/councillors'
          title={name}
          subtitle={title}
          pictureUrl={pictureUrl}
        />

        <Page
          title={`Councillor ${name} Record at the Toronto City Council`}
          description={`${name} has an average attendance of ${attendanceRate}%, has attended ${secretMeetingsRate}% closed doors meetings, and represents ${numberOfPeopleRepresented}`}
        >
          <PageCard>
            <CardContent>
              <MetricVsAverage
                value={attendanceRate}
                averageValue={averageAttendanceRate}
                label='attendance'
                valueFormatter={this.percentageFormatter}
              />
            </CardContent>
          </PageCard>

          <PageCard>
            <CardContent>
              <MetricVsAverage
                value={secretMeetingsRate}
                averageValue={secretMeetingsRateAverage}
                label='closed meetings'
                invertColors
                valueFormatter={this.percentageFormatter}
              />
            </CardContent>
          </PageCard>

          {!isMayor &&
            <PageCard>
              <CardContent>
                <MetricVsAverage
                  value={numberOfPeopleRepresented}
                  averageValue={numberOfPeoplePerCouncillor}
                  label={`represented by ${firstName}`}
                  valueFormatter={this.kFormatter}
                />
              </CardContent>
            </PageCard>
          }
        </Page>
      </Fragment>
    )
  }
}

export default CouncillorPage



// WEBPACK FOOTER //
// ./src/components/CouncillorPage/CouncillorPage.js